var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',{staticClass:"company-logos"},_vm._l((_vm.companies),function(company,index){return _c('a',{key:index,staticClass:"mr-4",attrs:{"href":company.url,"target":"_blank"}},[_c('img',{staticClass:"company-logo",class:_vm.size,attrs:{"src":_vm.url(company.logo)}})])}),0)
}
var staticRenderFns = []

export { render, staticRenderFns }